    
const HAS_WINDOWS = typeof window !== 'undefined'
const HAS_NAVIGATOR = typeof navigator !== 'undefined'
const IS_TOUCH =
  HAS_WINDOWS && ('ontouchstart' in window || (HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0))
const EVENTS = IS_TOUCH ? ['touchstart', 'click'] : ['click']
const IDENTITY = (item) => item

const directive = {
  instances: [],
}

function processDirectiveArguments(bindingValue, vnode) {
  const isFunction = typeof bindingValue === 'function'
  if (!isFunction && typeof bindingValue !== 'object') {
    throw new Error('v-click-outside: Binding value must be a function or an object')
  }

    var excludedRefs = [];
    if (bindingValue.exclude){
        bindingValue.exclude.forEach(refName => {
          var ref = vnode.context.$refs[refName];
          if (ref){
            excludedRefs.push(ref);
          }
        });
    }

  return {
    handler: isFunction ? bindingValue : bindingValue.handler,
    middleware: bindingValue.middleware || IDENTITY,
    events: bindingValue.events || EVENTS,
    isActive: !(bindingValue.isActive === false),
    exclude: excludedRefs
  }
}

function onEvent({ el, event, handler, middleware, exclude }) {
    let clickedOnExcludedEl = false
    if (exclude){
        exclude.forEach(excludedEl => {
            if (!clickedOnExcludedEl) {
                if (excludedEl){
                    clickedOnExcludedEl = excludedEl.contains(event.target)
                }
            }
        });
    }
            
    const isClickOutside = !clickedOnExcludedEl && event.target !== el && !el.contains(event.target)

    if (!isClickOutside) {
        return
    }

    if (middleware(event, el)) {
        handler(event, el)
    }
}

function createInstance({ el, events, handler, middleware, exclude }) {
  return {
    el,
    eventHandlers: events.map((eventName) => ({
      event: eventName,
      handler: (event) => onEvent({ event, el, handler, middleware, exclude }),
    })),
  }
}

function removeInstance(el) {
  const instanceIndex = directive.instances.findIndex((instance) => instance.el === el)
  if (instanceIndex === -1) {
    // Note: This can happen when active status changes from false to false
    return
  }

  const instance = directive.instances[instanceIndex]

  instance.eventHandlers.forEach(({ event, handler }) =>
    document.removeEventListener(event, handler),
  )

  directive.instances.splice(instanceIndex, 1)
}

function bind(el, { value }, vnode) {
  setTimeout(function(){
    const { events, handler, middleware, isActive, exclude} = processDirectiveArguments(value, vnode)

    if (!isActive) {
      return
    }

    const instance = createInstance({ el, events, handler, middleware, exclude })

    instance.eventHandlers.forEach(({ event, handler }) =>
      setTimeout(() => document.addEventListener(event, handler), 0),
    )
    directive.instances.push(instance)
  }, 10);
}

function update(el, { value, oldValue }) {
  if (JSON.stringify(value) === JSON.stringify(oldValue)) {
    return
  }

  const { events, handler, middleware, isActive, exclude} = processDirectiveArguments(value)

  if (!isActive) {
    removeInstance(el)
    return
  }

  let instance = directive.instances.find((instance) => instance.el === el)

  if (instance) {
    instance.eventHandlers.forEach(({ event, handler }) =>
      document.removeEventListener(event, handler),
    )
    instance.eventHandlers = events.map((eventName) => ({
      event: eventName,
      handler: (event) => onEvent({ event, el, handler, middleware }),
    }))
  } else {
    instance = createInstance({ el, events, handler, middleware })
    directive.instances.push(instance)
  }

  instance.eventHandlers.forEach(({ event, handler }) =>
    setTimeout(() => document.addEventListener(event, handler), 0),
  )
}

directive.bind = bind
directive.update = update
directive.unbind = removeInstance

export default directive